<template>
  <span :class="['badge', type, size]">{{ count }}</span>
</template>

<script>
export default {
  name: "BadgeDefault",
  props: {
    'count': {
      type: Number,
      required: true
    },
    'type': {
      type: String
    },
    'size': {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.badge {
  display: inline-block;
  height: 16px;
  min-width: 20px;
  padding: 0 5px;
  background: $primary;
  border-radius: 16px;
  font-size: 10px;
  font-weight: bold;
  font-family: "Arial", "Helvetica", sans-serif;
  color: #fff;
  text-align: center;
  line-height: 18px;

  &.danger {
    background: $red;
  }

  &.warning {
    background: $yellow;
  }

  &.success {
    background: $green;
  }

  &.is-large {
    height: 18px;
    min-width: 24px;
    border-radius: 20px;
    font-size: 14px;
    line-height: 18px;
  }
}
</style>
